var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text--title",class:{
    'text--title-white': _vm.white,
    'text--title-uppercase': _vm.uppercase,
    'text--title--xlarge': _vm.xlargeSize,
    'text--title-secondary': _vm.secondaryStyle,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }